<script setup lang="ts">
import { cn } from 'cn'
import { computed, type HTMLAttributes } from 'vue'
import {
  SelectItem,
  SelectItemIndicator,
  type SelectItemProps,
  SelectItemText,
  useForwardProps,
} from 'reka-ui'

import { selectClasses } from './variants'

const props = defineProps<SelectItemProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectItem
    v-bind="forwardedProps"
    :class="
      cn(
        selectClasses.menuButton,
        props.class,
      )
    "
  >
    <slot name="content">
      <SelectItemText>
        <slot />
      </SelectItemText>
    </slot>

    <slot name="description" />

    <span :class="selectClasses.menuButtonIconContainer">
      <SelectItemIndicator>
        <UiIcon
          name="docue:check"
          :class="selectClasses.menuButtonIcon"
        />
      </SelectItemIndicator>
    </span>
  </SelectItem>
</template>
